import React from "react";
import ProductsList from "components/products/ProductsList";

const Products: React.FC = () => {
  return (
    <div>
      <h1 className="text-2xl font-semibold text-gray-900 mb-6">
        Lista Prodotti
      </h1>
      <ProductsList />
    </div>
  );
};

export default Products;
